import React from "react";
import { Link } from "react-router-dom";
import { RoleHelper } from "src/helpers";
import { ROUTES_CONFIG } from "src/constants/routesConfig";
import { useAuthorisation } from "src/context";
import { IconButton } from "src/components";

interface SendPurchaseOrderBtnProps {
  id: string;
  vendorName?: string;
}

const SendPurchaseOrderBtn: React.FC<SendPurchaseOrderBtnProps> = ({ id, vendorName }) => {
  const { userRole } = useAuthorisation();

  if (!RoleHelper.isHealfOperationsTeam(userRole)) {
    return null;
  }

  const urlParams = new URLSearchParams();
  urlParams.set("id", id);

  if (vendorName) {
    urlParams.set("vendor", encodeURIComponent(vendorName));
  }

  const route = `${ROUTES_CONFIG.sendPurchaseOrder.path}?${urlParams.toString()}`;

  return (
    <span style={{ margin: "0 5px" }}>
      <Link to={route}>
        <IconButton icon="SEND" />
      </Link>
    </span>
  );
};

export { SendPurchaseOrderBtn };
